(function () {
  'use strict';

  var PAGE = 'buildmystack';

  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    payload.review_carousel_page = PAGE;
    window.dataLayer.push(payload);
  }

  // click_read_all_reviews — the link lives in its own rich-text button
  // section (not inside the Okendo widget) and is static Liquid markup, so
  // bind it immediately via document-level delegation.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (link && /^read all reviews$/i.test((link.textContent || '').trim())) {
      push({ event: 'click_read_all_reviews' });
    }
  });

  var CAROUSEL_SELECTOR = '[data-oke-carousel] .oke-reviewCarousel';

  // Okendo renders the carousel client-side after the page loads, so wait for
  // it to mount before binding listeners.
  function whenCarouselReady(cb) {
    var existing = document.querySelector(CAROUSEL_SELECTOR);
    if (existing) {
      cb(existing);
      return;
    }
    var observer = new MutationObserver(function () {
      var el = document.querySelector(CAROUSEL_SELECTOR);
      if (el) {
        observer.disconnect();
        cb(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  whenCarouselReady(function (carousel) {
    var section = carousel.closest('.apps.section') || carousel;

    // view_reviews_carousel — once, when the carousel scrolls into view.
    var viewed = false;
    function markViewed() {
      if (viewed) return;
      viewed = true;
      push({ event: 'view_reviews_carousel' });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            markViewed();
            io.disconnect();
          }
        });
      }, { threshold: 0.3 });
      io.observe(carousel);
    } else {
      markViewed();
    }

    // scroll_reviews_carousel — once, on first navigation (arrow click or swipe).
    var navigated = false;
    function markNavigated() {
      if (navigated) return;
      navigated = true;
      push({ event: 'scroll_reviews_carousel' });
    }

    section.addEventListener('click', function (e) {
      // Prev/next navigation counts as carousel scroll engagement.
      if (e.target.closest('.oke-prevNextButton, [class*="prevNext"], [aria-label="Next"], [aria-label="Previous"]')) {
        markNavigated();
        return;
      }

      // click_review_card — any click within a review card.
      var card = e.target.closest('[class*="reviewCarousel-review"], [class*="reviewCard"], .hooper-slide');
      if (card) {
        var slide = e.target.closest('.hooper-slide');
        var index = slide && slide.parentNode
          ? Array.prototype.indexOf.call(slide.parentNode.children, slide)
          : null;
        push({ event: 'click_review_card', review_card_index: index });
      }
    });

    // Touch swipe on the carousel track also counts as scroll engagement.
    var track = carousel.querySelector('.oke-reviewCarousel-reviews') || carousel;
    var touchStartX = null;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches && e.touches.length ? e.touches[0].clientX : null;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var endX = e.changedTouches && e.changedTouches.length ? e.changedTouches[0].clientX : touchStartX;
      if (Math.abs(endX - touchStartX) > 30) markNavigated();
      touchStartX = null;
    }, { passive: true });
  });
})();
